// Vuetify
import { createVuetify } from 'vuetify'
import * as labs from 'vuetify/labs/components'
// Styles
import 'vuetify/styles'
import { aliases, remix } from '@/iconsets/remix'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const pdsLightTheme = {
  dark: false,
  colors: {
    primary: '#002469',
    secondary: '#6699C2',
    accent: '#82B1FF',
    error: '#D71A17',
    info: '#BDE5FF',
    success: '#029949',
    warning: '#E0AB06',
    white: '#FFFFFF',
    black: '#000000',
    alert_gold: '#E0AB06',
    alert_green: '#029949',
    brand_red: '#AD2624',
    brand_green: '007336',
    base_light_grey: '#EBEBEB',
    agency_light_grey: '#F4F4F4',
    disabled_steppers: '#949494',
  },
}

const pdsDarkTheme = {
  dark: true,
  colors: {
    primary: '#2962FF',
    secondary: '#B388FF',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#BDE5FF',
    success: '#4CAF50',
    warning: '#FFC107',
    white: '#FFFFFF',
    black: '#000000',
    alert_gold: '#E0AB06',
    alert_green: '#029949',
    brand_red: '#AD2624',
    brand_green: '007336',
    base_light_grey: '#EBEBEB',
    agency_light_grey: '#F4F4F4',
    disabled_steppers: '#949494',
  },
}

const vuetify = createVuetify({
  directives,
  components: {
    ...components,
    ...labs,
  },
  icons: {
    defaultSet: 'remix',
    aliases,
    sets: {
      remix,
    },
  },
  theme: {
    defaultTheme: 'pdsLightTheme',
    themes: {
      pdsLightTheme,
      pdsDarkTheme,
    },
  },
  defaults: {
    global: {
      ripple: false,
    },
    VRow: { density: 'compact' },
    VIcon: {
      size: 'x-small',
    },
    VCheckbox: {
      density: 'compact',
    },
    VTable: {
      density: 'compact',
    },
    VTextField: {
      density: 'comfortable',
    },
    VTextarea: {
      density: 'comfortable',
    },
    VInput: {
      density: 'comfortable',
    },
    VSelect: {
      density: 'comfortable',
    },
    VAutocomplete: {
      density: 'comfortable',
    },
    VDialog: {
      transition: 'dialog-top-transition',
    },
  },
})
export default vuetify
